



export function alertas({
  type = "info",
  title = "Notice",
  message = "",
  buttonText = "OK",
  onConfirm = null,
  redirect = null,
  autoClose = 0 // milisegundos, 0 = no cerrar automáticamente
}) {
  // eliminar popup previo
  const old = document.getElementById("iosPopupOverlay");
  if (old) old.remove();

  // colores por tipo
  const COLORS = {
    info:    "#007AFF",
    success: "#34C759",
    warning: "#FF9F0A",
    error:   "#FF3B30"
  };

  const BTN_COLOR = COLORS[type] || COLORS.info;

  const ICONS = {
  info: "ℹ️",
  success: "✅",
  warning: "⚠️",
  error: "❌"
};

  const ICON = ICONS[type] || ICONS.info;
  

  // estilos (solo se insertan una vez)
  if (!document.getElementById("iosAlertStyle")) {
    const style = document.createElement("style");
    style.id = "iosAlertStyle";
    style.innerHTML = `
      #iosPopupOverlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.45);
        backdrop-filter: blur(6px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2147483647;
        animation: fadeIn 0.2s ease-out;
      }

      #iosPopupCard {
        position: relative;
        background: #fff;
        width: 85%;
        max-width: 360px;
        padding: 26px 22px 22px;
        border-radius: 18px;
        text-align: center;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto;
        animation: slideUp 0.25s ease-out;
      border-top: 6px solid var(--alert-color);
      border-left: 5px solid var(--alert-color);
      overflow: hidden;
      }

      #iosPopupCard h2 {
        margin: 0 0 10px;
        font-size: 20px;
        font-weight: 600;
        color: #111;
      }

      #iosPopupCard p {
        font-size: 16px;
        color: #444;
        line-height: 1.35;
      }

      .iosBtn {
        margin-top: 18px;
        color: #fff;
        padding: 12px;
        width: 100%;
        border-radius: 12px;
        border: none;
        font-size: 16px;
        cursor: pointer;
        font-weight: 500;
      }

      .iosCloseBtn {
        position: absolute;
        top: 10px;
        left: 10px;
        background: rgba(0,0,0,0.08);
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 18px;
        color: #333;
        user-select: none;
      }

      .iosCloseBtn:hover {
        background: rgba(0,0,0,0.15);
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @keyframes slideUp {
        from { transform: translateY(40px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // overlay
  const overlay = document.createElement("div");
  overlay.id = "iosPopupOverlay";

  // card
  const card = document.createElement("div");
  card.id = "iosPopupCard";
  card.style.setProperty("--alert-color", BTN_COLOR);

  // close
  const closeBtn = document.createElement("div");
  closeBtn.className = "iosCloseBtn";
  closeBtn.innerHTML = "✕";
  closeBtn.onclick = () => overlay.remove();

  // content
  card.innerHTML = `
    <div style="
        font-size:46px;
        margin-bottom:12px;
    ">
        ${ICON}
    </div>

    <h2>${title}</h2>

    <p>${message}</p>
  `;

  // button
  const button = document.createElement("button");
  button.className = "iosBtn";
  button.style.background = BTN_COLOR;
  button.innerText = buttonText;

  button.onclick = () => {
      overlay.remove();

      if (typeof onConfirm === "function") {
        onConfirm();
      }

      if (redirect) {
        location.href = redirect;
      }
    };

  card.appendChild(closeBtn);
  card.appendChild(button);
  overlay.appendChild(card);
  document.body.appendChild(overlay);

  // Cierre automático
if (autoClose > 0) {
  // Ocultar el botón porque no será necesario
  button.style.display = "none";
  closeBtn.style.display = "none";

  setTimeout(() => {
    if (overlay.parentNode) {
      overlay.remove();

      if (typeof onConfirm === "function") {
        onConfirm();
      }

      if (redirect) {
        location.href = redirect;
      }
    }
  }, autoClose);
}


}






export function popupFullscreen({
  type = "info",        // info | success | warning | error
  title = "Título",
  subtitle = "",
  content = "",

  // botones
  showButtons = false,

  cancelText = "Cancelar",
  continueText = "Continuar",

  onCancel = null,
  onContinue = null,

  redirectCancel = null,
  redirectContinue = null

}) {

  // eliminar popup previo
  const old = document.getElementById("iosFullscreenOverlay");
  if (old) old.remove();


  // colores
  const COLORS = {
    info:    "#2db1cb",
    success: "#34C759",
    warning: "#FF9F0A",
    error:   "#FF3B30"
  };

  const BTN_COLOR = COLORS[type] || COLORS.info;


  // insertar estilos una sola vez
  if (!document.getElementById("iosFullscreenStyle")) {

    const style = document.createElement("style");
    style.id = "iosFullscreenStyle";

    style.innerHTML = `

      #iosFullscreenOverlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.45);
        backdrop-filter: blur(10px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999999;
        animation: fadeIn 0.25s ease;
      }

      #iosFullscreenCard {
        position: relative;
        width: 94%;
        height:90%;
        max-width: 700px;
        background: #fff;
        display: flex;
        flex-direction: column;
        font-family:
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        Roboto;
        animation: slideUp 0.25s ease;
      }

      .iosFullscreenHeader {
        padding: 20px 20px 10px 20px;
        border-bottom: 1px solid #eee;
      }

      .iosFullscreenHeader h2 {
        margin: 0;
        font-size: 22px;
        font-weight: 600;
        color: #111;
      }

      .iosFullscreenHeader h3 {
        margin: 6px 0 0 0;
        font-size: 15px;
        font-weight: 400;
        color: #666;
      }

      .iosFullscreenContent {
        flex: 1;
        overflow-y: auto;
        padding: 20px;
        font-size: 16px;
        color: #333;
        line-height: 1.5;
      }

      .iosFullscreenFooter {
        padding: 15px 20px;
        border-top: 1px solid #eee;
        display: flex;
        gap: 10px;
      }

      .iosFullscreenBtn {
        flex: 1;
        padding: 14px;
        border: none;
        font-size: 17px;
        font-weight: 500;
        color: #fff;
        cursor: pointer;
      }

      .iosFullscreenBtnCancel {
        background: #ccc;
        color: #333;
      }

      .iosFullscreenClose {
        position: absolute;
        top: 14px;
        right: 14px;
        width: 32px;
        height: 32px;
        background: rgb(251 21 21 / 74%);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 18px;
      }

      .iosFullscreenClose:hover {
        background: rgba(0,0,0,0.15);
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @keyframes slideUp {
        from {
          transform: translateY(40px);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }

    `;

    document.head.appendChild(style);
  }


  // overlay
  const overlay = document.createElement("div");
  overlay.id = "iosFullscreenOverlay";


  // card
  const card = document.createElement("div");
  card.id = "iosFullscreenCard";


  // close icon
  const close = document.createElement("div");
  close.className = "iosFullscreenClose";
  close.innerHTML = "✕";

  close.onclick = () => {

    overlay.remove();

    if (typeof onCancel === "function") {
      onCancel();
    }

    if (redirectCancel) {
      location.href = redirectCancel;
    }

  };


  // header
  const header = document.createElement("div");
  header.className = "iosFullscreenHeader";

  header.innerHTML = `
    <h2>${title}</h2>
    ${subtitle ? `<h3>${subtitle}</h3>` : ""}
  `;


  // body
  const body = document.createElement("div");
  body.className = "iosFullscreenContent";
  body.innerHTML = content;


  card.appendChild(close);
  card.appendChild(header);
  card.appendChild(body);


  // FOOTER con botones
  if (showButtons) {

    const footer = document.createElement("div");
    footer.className = "iosFullscreenFooter";


    // CANCELAR
    const cancelBtn = document.createElement("button");
    cancelBtn.className = "iosFullscreenBtn iosFullscreenBtnCancel";
    cancelBtn.innerText = cancelText;

    cancelBtn.onclick = () => {

      overlay.remove();

      if (typeof onCancel === "function") {
        onCancel();
      }

      if (redirectCancel) {
        location.href = redirectCancel;
      }

    };


    // CONTINUAR
    const continueBtn = document.createElement("button");
    continueBtn.className = "iosFullscreenBtn";
    continueBtn.style.background = "linear-gradient(180deg, var(--accent), rgba(85, 240, 201, 0.92))";
    continueBtn.style.color = "#333333";
    continueBtn.style.boxShadow = "0 20px 50px rgba(46, 215, 255, 0.18)";
    continueBtn.innerText = continueText;

    continueBtn.onclick = () => {

      //overlay.remove();

      if (typeof onContinue === "function") {
        onContinue();
      }

      if (redirectContinue) {
        location.href = redirectContinue;
      }

    };

    footer.appendChild(cancelBtn);
    footer.appendChild(continueBtn);

    card.appendChild(footer);
  }


  overlay.appendChild(card);
  document.body.appendChild(overlay);


  // sonido opcional
  if (typeof playSound === "function") {
    playSound(type);
  }

}



